var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupAdminAddicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:none;stroke:#f0f3f6;stroke-linecap:round;stroke-width:1.2px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.008,
    y1: 0.075,
    x2: 0.992,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4083f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#609bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b79e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#548ded"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.066 3.789) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 5.963,
    x2: 5.995,
    transform: "translate(0 0.037)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 6,
    y2: 6
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupAdminAddicon);
export default __webpack_public_path__ + "static/media/GroupAdminAddicon.cb97069f3f356b95a7c9c87dacd57725.svg";
export { ForwardRef as ReactComponent };